<template>
    <div v-if="!isClose">
        <keep-alive>
            <component
                :is="componentName"
                v-bind="componentData"
                @close="closePopup"
                @cancel="closePopup"
                @showAuthModal="showAuthModal"
                @carouselChange="carouselChange"
            />
        </keep-alive>
    </div>
</template>

<script>
import {PopupEmitter} from '@/utils/eventEmitter.js';
import agentCreateDialog from '@/components/agent-create-dialog.vue';
import FreeVipDialog from '@/components/vip/free-vip-dialog.vue';
import uiCarousel from '@/components/law/ui-carousel';
import agentCreateDialogNew from '@/components/agent-create-dialog-new.vue';
import ClaimAgentModal from '@/components/biz/claim-agent-modal';
import ConsultImproveDialog from '@/components/biz/consult-improve-dialog';

export default {
    name: 'PopupComponent',
    components: {
        'agent-create-dialog': agentCreateDialog,
        'free-vip-dialog': FreeVipDialog,
        'ui-carousel': uiCarousel,
        // eslint-disable-next-line
        'agent-create-dialog-new': agentCreateDialogNew,
        'claim-agent-modal': ClaimAgentModal,
        'consult-improve-dialog': ConsultImproveDialog
    },
    data() {
        return {
            isClose: true,
            componentName: '', // popup组件名称
            componentData: {}, // popup 数据
            emitter: null // 通信实例
        };
    },
    created() {
        // 获取通信实例
        this.emitter = PopupEmitter.getInstance();
    },
    mounted() {
        // 注册通信通道
        this.registerBroadcast();
    },
    methods: {
        // 接收业务逻辑中从弹窗实例发出的消息
        registerBroadcast() {
            this.emitter?.registerBroadcast(data => {
                const {componentData, componentName} = data?.data || {};
                const components = this.getComponents();
                // 接受到的事件进行处理/中转
                switch (data.type) {
                    case 'show':
                        if (!components.includes(componentName)) {
                            this.closePopup();
                            return;
                        }
                        // 打开新弹窗时关闭状态重置
                        this.isClose = false;
                        this.componentName = componentName;
                        this.componentData = componentData;
                        break;
                    case 'close':
                        this.closePopup();
                        break;
                }
            });
        },

        // 关闭弹窗
        closePopup() {
            if (this.isClose) {
                return;
            }
            this.isClose = true;
            this.componentName = '';
            this.componentData = {};
        },

        // 向业务逻辑中的弹窗实例发送消息
        sendBroadcast(data) {
            this.emitter?.sendBroadcast(data);
        },

        unRegisterBroadcast() {
            this.emitter?.unRegisterBroadcast();
        },

        getComponents() {
            const components = this.$options.components || {};
            const componentNames = Object.keys(components);
            return componentNames;
        },

        showAuthModal() {
            this.$emit('showAuthModal');
        },

        carouselChange(...args) {
            this.$emit('carouselChange', ...args);
        }
    },
    destroyed() {
        this.closePopup();
        // 注销通信通道
        this.unRegisterBroadcast();
    }
};
</script>

<style></style>